import React from "react";
import { Video } from "./VideoPlayer.style";

interface Props {
  thumbnail?: string;
  video: string;
  subtitle?: string;
}
const getVideoType = (url: string) => {
  const types = [
    {
      name: "mp4",
      regex: "/*.mp4"
    },
    {
      name: "webm",
      regex: "/*.webm"
    },
    {
      name: "ogg",
      regex: "/*.ogv"
    }
  ];
  for (let i = 0, n = types.length; i < n; i++) {
    if (RegExp(types[i].regex).test(url)) return types[i].name;
  }
};

const VideoPlayer: React.FC<Props> = props => {
  return (
    <Video controls>
      <source src={props.video} type={`video/${getVideoType(props.video)}`} />
      {props.subtitle && <track src={props.subtitle} default kind="captions" />}
    </Video>
  );
};

export default VideoPlayer;
